// import {
//   createEmptyState,
//   createModifiedState,
//   createStateFromTemplate,
//   exportState,
//   exportTextOverlays,
//   getBackgroundColor,
//   getProgressAnimationOptions,
//   getSoundwave,
//   getStateContent,
//   getTimerOptions,
//   isErrorAction,
// } from './state';
// import * as stateUtils from './state/state-utils';
import { VideoTemplateEditorFeatures } from './context/VideoEditorStateContext';
import { api } from './state';
import { isErrorAction } from './state/template/shared/actions';
import useIntroOutroInit from './useIntroOutroInit';
import useLoadTextOverlayFonts from './useLoadTextOverlayFonts';
import useVideoTemplateEditorState, {
  UseVideoTemplateEditorConfig,
} from './useVideoTemplateEditorState';
import { createDefaultSoundwave } from './utils';

export { default, VideoTemplateEditorProps } from './VideoTemplateEditor';
export {
  default as VideoTemplateEditorContextProvider,
  VideoTemplateEditorMedia,
} from './context';
export { default as EditorPane, EditorPaneProps } from './EditorPane';
export {
  useVideoTemplateEditorState,
  UseVideoTemplateEditorConfig,
  useIntroOutroInit,
  useLoadTextOverlayFonts,
  createDefaultSoundwave,
  VideoTemplateEditorFeatures,
};

export { api as EditorState };

// export const EditorState = {
//   createEmptyState,
//   createModifiedState,
//   createStateFromTemplate,
//   exportState,
//   exportTextOverlays,
//   getBackgroundColor,
//   getProgressAnimationOptions,
//   getSoundwave,
//   getTimerOptions,
//   getContent: getStateContent,
//   ...stateUtils,
// };

export const ActionUtils = {
  isErrorAction,
};

export * from './types';

// export * from './state-v2/api';
